import React, { useState, useRef, useEffect, useCallback, useMemo } from "react";
import Slider from "react-slick";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

// Optimized ImageWithLoader component
const ImageWithLoader = ({ src, alt, className, loader, canLoad, onLoaded }) => {
  const [loading, setLoading] = useState(true);
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    if (!canLoad) {
      setLoading(true);
      setImageLoaded(false);
    }
  }, [canLoad]);

  const handleImageLoad = () => {
    setLoading(false);
    setImageLoaded(true);
    if (onLoaded) {
      onLoaded();
    }
  };

  return (
    <div className="image-with-loader" style={{ position: 'relative', width: '100%', height: '100%' }}>
      {!canLoad || loading ? (
        <div className="skeleton-image" style={{
          width: '100%',
          height: '200px',
          backgroundColor: '#e0e0e0',
          animation: 'pulse 1.5s ease-in-out infinite',
          marginRight:'2px'
        }}></div>
      ) : null}
      
      {canLoad && (
        <img
          src={src}
          alt={alt}
          className={`${className} ${!imageLoaded ? 'hidden' : ''}`}
          style={{ 
            display: imageLoaded ? 'block' : 'none',
            width: '100%',
            height: 'auto'
          }}
          onLoad={handleImageLoad}
          onError={handleImageLoad}
        />
      )}
    </div>
  );
};

const SLIDER_SETTINGS = {
  dots: false,
  infinite: true,
  speed: 600,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true,
  autoplay: false, 
  cssEase: "linear",
  centerMode: false,
  variableWidth: false,
  autoplaySpeed: 2000,
  responsive: [
    {
      breakpoint: 1024,
      settings: { slidesToShow: 2, slidesToScroll: 2, infinite: true, dots: true },
    },
    {
      breakpoint: 600,
      settings: { slidesToShow: 2, slidesToScroll: 2, initialSlide: 2 },
    },
    {
      breakpoint: 480,
      settings: { slidesToShow: 1, slidesToScroll: 1 },
    },
  ],
};

const OptimizedCarousel = ({ item, clusterIndex, clusterData, IMG_URL, loadimg }) => {
  const [loadedImagesCount, setLoadedImagesCount] = useState(0);
  const [allImagesLoaded, setAllImagesLoaded] = useState(false);
  const sliderRef = useRef(null);

  const totalImages = item.dimension?.length || 0;

  const startingIndex = useMemo(() => {
    return clusterData
      .slice(0, clusterIndex)
      .reduce((sum, cur) => sum + (cur.dimension?.length || 0), 0);
  }, [clusterData, clusterIndex]);

  const handleImageLoaded = useCallback(() => {
    setLoadedImagesCount((prev) => {
      const newCount = prev + 1;
      if (newCount >= totalImages) {
        setAllImagesLoaded(true);

        setTimeout(() => {
          if (sliderRef.current) {
            sliderRef.current.slickPlay();
          }
        }, 100);
      }
      return newCount;
    });
  }, [totalImages]);

  const canLoadImage = useCallback((position) => {
 
    return position <= loadedImagesCount;
  }, [loadedImagesCount]);

  return (
    <div className="carousel-container">
      <Slider ref={sliderRef} {...SLIDER_SETTINGS}>
        {item.dimension?.map((value, j) => {
          const shouldLoad = canLoadImage(j);

          return (
            <div
              className="clasi-cont2-card"
              key={value.slug || `${clusterIndex}-${j}`}
              style={{ padding: '10px' }}
            >
              <a
                href={`/arche-detail/${value?.slug}`}
                className="clas-img-div"
                style={{ display: 'block', textDecoration: 'none' }}
              >
                <ImageWithLoader
                  src={`${IMG_URL}/d0/${value.image}`}
                  alt={value?.imagealt}
                  className="clasi-img"
                  loader={loadimg}
                  canLoad={shouldLoad}
                  onLoaded={handleImageLoaded}
                />
              </a>
              <div className="clasi-text-cont" style={{ padding: '10px' }}>
                <p style={{ fontWeight: 'bold', marginBottom: '5px' }}>{value?.name}</p>
                <p style={{ fontSize: '14px', color: '#666' }}>{value?.description}</p>
              </div>
            </div>
          );
        })}
      </Slider>
      
      {!allImagesLoaded && (
        <div style={{ 
          textAlign: 'center', 
          marginTop: '10px', 
          fontSize: '12px', 
          color: '#999' 
        }}>
        </div>
      )}
    </div>
  );
};

export default OptimizedCarousel;